import { AIAssistantContext } from './AIAssistantProvider';
import { useContext } from 'react';

export default function useAIAssistant() {
    const context = useContext(AIAssistantContext);
    if (!context) {
        throw new Error('useAIAssistant must be used within an <AIAssistantProvider>');
    }
    return context;
}
